// TODO: Has this api spelling been fixed?
/* cspell:words Tempate */

import moment from 'moment';
import { createAction, createReducer } from '@reduxjs/toolkit';

import callApi, {
  createApiFailureAction,
  createApiRequestAction,
  createApiSuccessAction,
} from '@helpers/callApi';
import callGraphQLApi, {
  createGraphQLFailureAction,
  createGraphQLRequestAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';
import { selectCurrentRoutePayload } from '@common-modules/routing';
import { Brand } from '@utils';
import { FolderId, TreeObjectId } from '@cbsa/state/modules/universal';

export const SHOW_CREATE_FORM = createAction('show_create_form');
export const HIDE_CREATE_FORM = createAction('hide_create_form');
export const CREATE_CASE_REQUEST = createAction<any[]>('create case request');
export const SHOW_UPLOAD_FORM_BY_UPLOAD_BUTTON = createAction<string>(
  'show upload form by upload button'
);
export const SHOW_UPLOAD_FORM = createAction<string>('show upload form');
export const HIDE_UPLOAD_FORM = createAction('hide upload form');
export const UPLOAD_SUBMIT = createAction<{ file: File; key: string }>(
  'upload submit'
);

export const CREATE_CASE = 'create case';
export const CREATE_CASE_SUCCESS = 'create case success';
export const CREATE_CASE_FAILURE = 'create case failure';

export const CREATE_SDO = createGraphQLRequestAction('create sdo');
export const CREATE_SDO_SUCCESS = createGraphQLSuccessAction<{
  createStructuredData: {
    id: string;
  };
}>('create sdo success');
export const CREATE_SDO_FAILURE =
  createGraphQLFailureAction('create sdo failure');

export const UPDATE_SDO_FOR_CASE = 'update sdo for case';
export const UPDATE_SDO_FOR_CASE_SUCCESS = createGraphQLSuccessAction(
  'update sdo for case success'
);
export const UPDATE_SDO_FOR_CASE_FAILURE = createGraphQLFailureAction(
  'update sdo for case failure'
);

export const CREATE_FOLDER_CONTENT_TEMPLATE = 'create folder content template';
export const CREATE_FOLDER_CONTENT_TEMPLATE_SUCCESS =
  createGraphQLSuccessAction<CreateFolderContentTemplateResponse>(
    'create folder content template success'
  );
export const CREATE_FOLDER_CONTENT_TEMPLATE_FAILURE =
  createGraphQLFailureAction('create folder content template failure');

export const UPLOAD_AVATAR = createApiRequestAction('upload avatar');
export const UPLOAD_AVATAR_SUCCESS = createApiSuccessAction<{
  createTDOWithAsset: {
    id: string;
    name: string;
  };
}>('upload avatar success');
export const UPLOAD_AVATAR_FAILURE = createApiFailureAction(
  'upload avatar failure'
);

interface UPLOAD_FILE_VARIABLES {
  folderId: string;
  key: string;
}
export const UPLOAD_FILE = 'upload file';
// export const UPLOAD_FILE_SUCCESS = createAction<any>('upload file success');
export const UPLOAD_FILE_SUCCESS = createApiSuccessAction<
  any,
  UPLOAD_FILE_VARIABLES
>('upload file success');
export const UPLOAD_FILE_FAILURE = createApiFailureAction<
  any,
  UPLOAD_FILE_VARIABLES
>('upload file failure');

export const STORE_FILE_UPLOADING = createAction<string>(
  'store file uploading'
);
export const STORE_FILE_UPLOAD_SUCCESS = createAction<string>(
  'store file upload success'
);
export const STORE_FILE_UPLOAD_FAILURE = createAction<string>(
  'store file upload failure'
);
export const UPLOAD_ALL_DONE = createAction('upload all done');

export const LINK_FILE_TO_FOLDER = createGraphQLRequestAction(
  'link file to folder'
);
export const LINK_FILE_TO_FOLDER_SUCCESS = createGraphQLSuccessAction(
  'link file to folder success'
);
export const LINK_FILE_TO_FOLDER_FAILURE = createGraphQLFailureAction(
  'link file to folder failure'
);

const defaultState = {
  isShowCreateForm: false,
  isShowUploadForm: false,
  uploading: <string[]>[],
  uploadSuccess: <string[]>[],
  uploadFailure: <string[]>[],
  editNoteModel: false,
  isUploading: false,
  isUploadDone: false,
  currentCaseIdForUpload: undefined as string | undefined, // TODO: I think this is unused
  calledFrom: undefined as string | undefined,
};

const reducer = createReducer(defaultState, (builder) => {
  builder
    .addCase(STORE_FILE_UPLOADING, (state, action) => ({
      ...state,
      uploading: [...state.uploading, action.payload],
    }))
    .addCase(STORE_FILE_UPLOAD_SUCCESS, (state, action) => ({
      ...state,
      uploadSuccess: [...state.uploadSuccess, action.payload],
    }))
    .addCase(STORE_FILE_UPLOAD_FAILURE, (state, action) => ({
      ...state,
      uploadFailure: [...state.uploadFailure, action.payload],
    }))
    .addCase(UPLOAD_SUBMIT, (state) => ({
      ...state,
      isUploading: true,
    }))
    .addCase(UPLOAD_ALL_DONE, (state) => ({
      ...state,
      isUploading: false,
      isUploadDone: true,
    }));
});

export default reducer;
export const namespace = 'overview';
export const local = (state: any) => state[namespace] as typeof defaultState;

export const showCreateForm = () => SHOW_CREATE_FORM();

export const hideCreateForm = () => HIDE_CREATE_FORM();

export const showUploadForm = (folderId: string) => SHOW_UPLOAD_FORM(folderId);

export const showUploadFormByUploadButton = (calledFrom: string) =>
  SHOW_UPLOAD_FORM_BY_UPLOAD_BUTTON(calledFrom);

export const hideUploadForm = () => HIDE_UPLOAD_FORM();

export const createCaseRequest = (values: unknown[]) =>
  CREATE_CASE_REQUEST(values);

export const uploadSubmit = (file: File, key: string) =>
  UPLOAD_SUBMIT({ file, key });

export const storeFileUploading = (fileUploadState: string) =>
  STORE_FILE_UPLOADING(fileUploadState);

export const storeFileUploadSuccess = (fileUploadState: string) =>
  STORE_FILE_UPLOAD_SUCCESS(fileUploadState);

export const storeFileUploadFailure = (fileUploadState: string) =>
  STORE_FILE_UPLOAD_FAILURE(fileUploadState);

export const uploadAllDone = () => UPLOAD_ALL_DONE();

export const createSDO =
  (treeObjectId: TreeObjectId, schemaId: string, data: Record<string, any>) =>
  async (dispatch: (d: any) => void, getState: () => any) => {
    const query = `
      mutation CreateStructuredData($data: JSONData) {
    createStructuredData(input: {
      schemaId: "${schemaId}",
      data: $data
    }) {
      id
    }
  }
    `;

    return await callGraphQLApi<{
      createStructuredData: {
        id: string;
      };
    }>({
      actionTypes: [CREATE_SDO, CREATE_SDO_SUCCESS, CREATE_SDO_FAILURE],
      query,
      variables: {
        objectTreeId: treeObjectId,
        data: data,
      },
      bailout: undefined,
      dispatch,
      getState,
    });
  };

export interface CreateFolderContentTemplateResponse {
  // TODO: Use the updated spelling when deployed
  createFolderContentTempate: {
    id: string;
    folderId: FolderId;
    sdoId: string;
    schemaId: string;
  };
}
export const createFolderContentTemplate =
  (treeObjectId: TreeObjectId, schemaId: string, sdoId: string) =>
  async (dispatch: (d: any) => void, getState: () => any) => {
    const query = `
      mutation {
    createFolderContentTempate(input: {
      folderId: "${treeObjectId}",
      sdoId: "${sdoId}",
      schemaId: "${schemaId}"
    }) {
      id
      folderId
      sdoId
      schemaId
    }
  }
    `;

    return await callGraphQLApi<CreateFolderContentTemplateResponse>({
      actionTypes: [
        CREATE_FOLDER_CONTENT_TEMPLATE,
        CREATE_FOLDER_CONTENT_TEMPLATE_SUCCESS,
        CREATE_FOLDER_CONTENT_TEMPLATE_FAILURE,
      ],
      query,
      variables: {},
      bailout: undefined,
      dispatch,
      getState,
    });
  };

type CaseSDOId = Brand<string, 'CaseSDO'>;
// Update case by force create structure data with provided id
export const updateCaseSDO =
  (schemaId: string, data: Record<string, any>, sdoId: CaseSDOId) =>
  async (dispatch: (d: any) => void, getState: () => any) => {
    const query = `
      mutation CreateStructuredData($data: JSONData) {
    createStructuredData(input: {
      id: "${sdoId}",
      schemaId: "${schemaId}",
      data: $data
    }) {
      id
    }
  }
    `;

    return await callGraphQLApi({
      actionTypes: [
        UPDATE_SDO_FOR_CASE,
        UPDATE_SDO_FOR_CASE_SUCCESS,
        UPDATE_SDO_FOR_CASE_FAILURE,
      ],
      query,
      variables: {
        data: data,
      },
      bailout: undefined,
      dispatch,
      getState,
    });
  };

export const uploadAvatar =
  (file: File | undefined, currentCaseId: string) =>
  async (dispatch: (d: any) => void, getState: () => any) => {
    if (!file) {
      return;
    }
    const startDateTime = new Date();

    const query = `
      mutation {
      createTDOWithAsset(input: {
        parentFolderId: "${currentCaseId}",
        startDateTime: "${moment.utc(startDateTime).toDate().toISOString()}",
        stopDateTime: "${moment.utc(startDateTime).toDate().toISOString()}",
        contentType: "${file.type}",
        assetType: "avatar"
      }) {
        id,
        name
      }
    }
    `;

    const body = new FormData();
    body.append('query', query);
    body.append('filename', file.name);
    body.append('file', file);

    return await callApi<{
      createTDOWithAsset: {
        id: string;
        name: string;
      };
    }>({
      actionTypes: [
        UPLOAD_AVATAR,
        UPLOAD_AVATAR_SUCCESS,
        UPLOAD_AVATAR_FAILURE,
      ],
      variables: {
        folderId: currentCaseId,
      },
      body: body,
      bailout: undefined,
      dispatch,
      getState,
    });
  };

export const uploadFile =
  (file: any, key: string) =>
  async (dispatch: (d: any) => void, getState: () => any) => {
    const startDateTime = new Date();
    let currentCaseId = selectCurrentCaseIdForUpload(getState());
    if (!currentCaseId) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      currentCaseId = selectCurrentRoutePayload(getState()).caseId;
    }

    const query = `
      mutation {
        createTDOWithAsset(input: {
          parentFolderId: "${currentCaseId}",
          startDateTime: "${moment.utc(startDateTime).toDate().toISOString()}",
          stopDateTime: "${moment
            .utc(startDateTime)
            .add(file.duration, 'ms')
            .toDate()
            .toISOString()}",
          contentType: "${file.type}",
          assetType: "media"
        }) {
          id,
          name
        }
      }
    `;

    const body = new FormData();
    body.append('query', query);
    body.append('filename', file.name);
    body.append('file', file);

    return await callApi<{
      createTDOWithAsset: {
        id: string;
        name: string;
      };
    }>({
      actionTypes: [UPLOAD_FILE, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAILURE],
      variables: {
        folderId: currentCaseId,
        key,
      },
      body: body,
      bailout: undefined,
      dispatch,
      getState,
    });
  };

export const linkFileToFolder =
  (fileId: string, folderId: string) =>
  async (dispatch: (d: any) => void, getState: () => any) => {
    const query = `
      mutation {
      fileTemporalDataObject(input: {
        tdoId: "${fileId}",
        folderId: "${folderId}"
      }) {
        id
      }
    }
    `;

    return await callGraphQLApi({
      actionTypes: [
        LINK_FILE_TO_FOLDER,
        LINK_FILE_TO_FOLDER_SUCCESS,
        LINK_FILE_TO_FOLDER_FAILURE,
      ],
      query,
      variables: {
        folderId: folderId,
      },
      bailout: undefined,
      dispatch,
      getState,
    });
  };

export const checkFullUploadDone =
  () => (dispatch: (d: any) => void, getState: () => any) => {
    const uploading = selectUploading(getState());
    const uploadSuccess = selectUploadSuccess(getState());
    const uploadFailure = selectUploadFailure(getState());
    if (
      uploading.length !== 0 &&
      uploading.length === uploadSuccess.length + uploadFailure.length
    ) {
      dispatch(uploadAllDone());
      setTimeout(() => {
        dispatch(hideUploadForm());
      }, 1000);
    }
  };

export const isShowCreateForm = (state: any) => local(state).isShowCreateForm;
export const isShowUploadForm = (state: any) => local(state).isShowUploadForm;
export const selectCurrentCaseIdForUpload = (state: any) =>
  local(state).currentCaseIdForUpload;
export const selectEditCaseModel = (state: any) => local(state).editNoteModel;
export const selectUploadCalledFrom = (state: any) => local(state).calledFrom;
export const selectUploading = (state: any) => local(state).uploading;
export const selectUploadSuccess = (state: any) => local(state).uploadSuccess;
export const selectUploadFailure = (state: any) => local(state).uploadFailure;
export const selectIsUploading = (state: any) => local(state).isUploading;
export const selectIsUploadDone = (state: any) => local(state).isUploadDone;
